import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import Input, { Select } from '../../components/ui/Input';
import { useToast } from '../../components/ui/Toast';
import api from '../../services/api';

export default function CreateTask() {
  const navigate = useNavigate();
  const toast = useToast();
  const [employees, setEmployees] = useState([]);
  const [stores, setStores] = useState([]);
  const [form, setForm] = useState({ title: '', type: 'osg', priority: 'normal', assigned_to: '', store_id: '', due_date: '' });

  useEffect(() => {
    async function load() {
      try {
        const [empRes, storesRes] = await Promise.allSettled([
          api.get('/v1/employees?page=1&per_page=100'),
          api.get('/v1/stores'),
        ]);
        if (empRes.status === 'fulfilled' && empRes.value?.data) setEmployees(empRes.value.data);
        if (storesRes.status === 'fulfilled' && storesRes.value?.data) setStores(storesRes.value.data);
      } catch (e) { console.error(e); }
    }
    load();
  }, []);

  const handleSubmit = async () => {
    if (!form.title) { toast('Введите название задачи', 'error'); return; }
    try {
      await api.post('/v1/tasks', form);
      toast('Задача создана', 'success');
      navigate('/tasks');
    } catch (e) { toast(e.message || 'Ошибка создания', 'error'); }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <Button variant="ghost" icon={<ArrowLeft size={15} />} onClick={() => navigate('/tasks')} size="sm">Назад</Button>
      </div>
      <h1 style={{ fontSize: 24, fontWeight: 800, color: '#0F172A', letterSpacing: '-0.02em' }}>Создать задачу</h1>
      <Card>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16, maxWidth: 520 }}>
          <Input label="Название задачи" value={form.title} onChange={e => setForm(f => ({ ...f, title: e.target.value }))} placeholder="Проверка ОСГ — Молочный отдел" required />
          <Select label="Тип" value={form.type} onChange={e => setForm(f => ({ ...f, type: e.target.value }))} options={[
            { value: 'osg', label: 'ОСГ проверка' },
            { value: 'display', label: 'Выкладка' },
            { value: 'inventory', label: 'Инвентаризация' },
          ]} />
          <Select label="Приоритет" value={form.priority} onChange={e => setForm(f => ({ ...f, priority: e.target.value }))} options={[
            { value: 'normal', label: 'Обычный' },
            { value: 'urgent', label: 'Срочный' },
          ]} />
          <Select label="Магазин" value={form.store_id} onChange={e => setForm(f => ({ ...f, store_id: e.target.value }))} options={[
            { value: '', label: 'Выберите магазин' },
            ...stores.map(s => ({ value: s.id, label: s.name })),
          ]} />
          <Select label="Исполнитель" value={form.assigned_to} onChange={e => setForm(f => ({ ...f, assigned_to: e.target.value }))} options={[
            { value: '', label: 'Выберите сотрудника' },
            ...employees.map(e => ({ value: e.id, label: e.name })),
          ]} />
          <Input label="Срок выполнения" type="date" value={form.due_date} onChange={e => setForm(f => ({ ...f, due_date: e.target.value }))} />
          <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
            <Button variant="secondary" onClick={() => navigate('/tasks')}>Отмена</Button>
            <Button onClick={handleSubmit}>Создать задачу</Button>
          </div>
        </div>
      </Card>
    </div>
  );
}
